import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { InternalEvent } from './internal-event'
import { InternalEventSerializer } from './internal-event.serializer'

@Injectable()
export class InternalEventService extends ResourceService<InternalEvent> {
  constructor(
    http: HttpClient,
    internalEventSerializer: InternalEventSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/internal-events`,
      internalEventSerializer
    )
  }
}
